import { commonKeys } from "app/pages/sales-intelligence/utils/i18n/common";
import dateTimeService from "app/services/date-time/dateTimeService";

import signalRecommenderI18nKeys from "./i18n";

const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

/**
 * How long ago a run started, in the same buckets the rest of SI uses for relative times.
 *
 * Hand-rolled rather than dayjs `fromNow()`: that plugin's output is English-only, and this line is
 * translated. Returns `null` when `created` carries no time of day — parsed as UTC it would read as
 * midnight, so a run that started minutes ago would claim to be hours old. Callers fall back to the
 * absolute date in that case.
 */
export const formatDealSignalElapsed = (created: string, translate: (key: string) => string): string | null => {
    if (!/\d{2}:\d{2}/.test(created)) {
        return null;
    }

    const minutes = dateTimeService.getDateDiffFromNow(created, "minute");

    if (minutes < 1) {
        return translate(signalRecommenderI18nKeys.list.elapsed.justNow);
    }

    if (minutes < MINUTES_IN_HOUR) {
        return `${minutes} ${translate(commonKeys.elapsed.minutesAgo)}`;
    }

    const hours = dateTimeService.getDateDiffFromNow(created, "hour");

    if (hours < HOURS_IN_DAY) {
        return `${hours} ${translate(commonKeys.elapsed.hoursAgo)}`;
    }

    return `${dateTimeService.getDateDiffFromNow(created, "day")} ${translate(commonKeys.elapsed.daysAgo)}`;
};
